import { FileSearch, type LucideIcon, Settings, ShieldCheck, UserRound } from "lucide-react";
import { MODULE_MANIFESTS } from "@/modules/module-registry";

/** One app of the platform in the switcher. `everyone` apps (My account) open for anyone signed in; the others only for people who hold a grant in their module. `needs` names a permission (read level) that must be held on top: the app-level permission of an app whose module also holds ordinary rights. */
export type AppModule = { id: string; href: string; icon: LucideIcon; everyone?: true; needs?: string };

// The apps shown in the switcher, one entry per app that has screens. An app marked `everyone` opens for anyone signed in; any other shows only for people who hold a grant in its module.
// Add an entry here for a core app when a module gets screens, and its name as auth.modules.<id> in the messages.

export const APP_MODULES: readonly AppModule[] = [
  { id: "account", href: "/account", icon: UserRound, everyone: true },
  { id: "documents", href: "/documents", icon: FileSearch },
  { id: "access", href: "/admin/access", icon: ShieldCheck },
  { id: "settings", href: "/settings", icon: Settings },
  // Optional modules (App store) come from their manifests; whether they are on is decided by the gate in `openApps`.
  ...MODULE_MANIFESTS.filter((m) => m.optional).map((m) => ({ id: m.id, href: m.href, icon: m.icon, needs: m.appPermission, everyone: m.everyone })),
];
